import * as Yup from 'yup';

export const searchBebyggelseobjektSchema = Yup.object().shape({
  bebyggelsenummer: Yup.string()
    .nullable()
    .test('Must start with a B', 'Bebyggelsenummer måste börja med B', (value) => !value || value.startsWith('B'))
    .test(
      'Year must start with 19 or 20',
      'Årtal måste börja på 19 eller 20',
      (value) => !value || /^(B19|B20|B$)/.test(value)
    )
    .test(
      'Must conform to format',
      'Bebyggelsenummer ska ha följande format: BÅÅÅÅ:N',
      (value) => !value || /^B(19|20)\d{2}:\d+$/.test(value)
    ),
  namn: Yup.string().min(3, 'Minst 3 tecken måste anges').max(255, 'Max 255 tecken kan anges'),
  skyddstyp: Yup.array().when('bebyggelsenummer', () => Yup.array().nullable()),
  kommun_kod: Yup.array().when('bebyggelsenummer', () => Yup.array().nullable()),
  lan_kod: Yup.array().when('bebyggelsenummer', () => Yup.array().nullable())
});

export interface SearchBebyggelseFormValues {
  bebyggelsenummer: string;
  namn: string;
  beteckning: string;
  skyddstyp: Array<string>;
  kommun_kod: Array<string>;
  lan_kod: Array<string>;
}
